export default "__VITE_ASSET__de1e130b__"